










import OptionalFeed from '@/component/view/OptionalFeed.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { TopicsService } from '@/kuroco_api';

@Component<TagFeed>({
  components: {
    OptionalFeed,
  },
})
export default class TagFeed extends Vue {}
